// extracted by mini-css-extract-plugin
export default {"root":"BotVerificationPane-module__root","icon":"BotVerificationPane-module__icon"};